export default {
  errors: {
    default: 'システムエラーが発生しました。もう一度試してみてください。',
    easy_payment_is_unavailable: '街コンかんたん決済をご利用いただけません。他の決済方法を選択して下さい。',
    card_easy_payment_is_unavailable: '有効期限が切れている、セキュリティコードが更新されている、限度額を超えている、などの理由により、前回のクレジットカードで決済を完了できませんでした。別のクレジットカードで決済を行ってください。',
    tickets: {
      not_match_gender:
        '%{userName}様は%{userGender}として登録されていますが、こちらは%{ticketGender}用のチケットです。ご購入のチケットの種類またはマイページの性別をご確認ください。',
      not_match_age_range: '%{userName}様は参加年齢条件を満たしておりません。マイページから年齢をご確認ください。',
      condition_time:
        'このイベントは、お客様がお申し込み済みのイベントの開始・終了時刻から30分未満の時間で終了・開始しているため、お申し込みいただくことができません。',
      duplicate_time: 'このイベントは、お客様がお申し込み済みのイベントと開催日時が重なってしまっているため、お申し込みいただくことができません。'
    },
    profile_form: {
      has_blank_profile: 'プロフィールに空欄があります。',
      invalid_name: '名前が正しくありません。',
      empty_birth_date: '生年月日が正しくありません。',
      invalid_birth_date: '生年月日が正しくありません。',
      invalid_length_birth_date: '生年月日を8桁で入力してください',
      out_of_target_age: 'イベントの対象年齢外のため申し込みできません。',
      cannot_register_under_18: '18歳未満は登録できません。',
      not_match_gender: 'このチケットは{ticketGender}用です。',
      invalid_email: 'メールアドレスが正しくありません。',
      invalid_phone_number: '認証用携帯番号が正しくありません。'
    },
    credit_card_form: {
      absent_card_name: 'クレジットカード名義が正しくありません。',
      invalid_card_number: 'クレジットカード番号が正しくありません。',
      invalid_cvc_number: 'セキュリティコードが正しくありません。',
      invalid_card_expiry: 'クレジットカード有効期限が正しくありません。'
    },
    guest_validate: {
      lack_of_request_params: 'プロフィール・クレジットカード情報を確認後、もう一度試してみてください。',
      not_match_profile_with_ticket: '年齢・性別が申し込みチケットの条件を満たしておりません。',
      ticket_unavailable: 'このチケットの販売は終了しました。',
      invalid_email_format: 'メールアドレスが正しくありません。',
      invalid_profile_format: 'プロフィール項目が正しくありません。確認後、もう一度試してみてください。',
      email_duplicated: 'このメールアドレスは既に登録されています。',
      invalid_profile: 'プロフィール項目が正しくありません。確認後、もう一度試してみてください。',
      unexpected_error_in_oss: 'システムエラーが発生しました。もう一度試してみてください。',
      access_locked: '不正な認証コードが複数回入力されたのでロックされました。ロックは八時間後に解除されます。',
      error_response_by_otp: 'システムエラーが発生しました。もう一度試してみてください。',
      unexpected_error_in_otp: 'システムエラーが発生しました。もう一度試してみてください。',
      lbi_error_30: 'このメールアドレスは既に登録されています。'
    },
    verify_otp: {
      invalid_profile_format: 'プロフィールが正しくありません。',
      access_locked: '不正な認証コードが複数回入力されたのでロックされました。ロックは八時間後に解除されます。',
      invalid_code: '認証コードが間違っています。',
      error_response_by_otp: 'システムエラーが発生しました。もう一度試してみてください。',
      unexpected_error_in_otp: 'システムエラーが発生しました。もう一度試してみてください。'
    },
    amazon_payment: {
      amzpay_invalid_access_token: 'お客様のセッションが切断されました。お手数ですが、再度ログインください。',
      not_match_profile_with_ticket: '年齢・性別が申し込みチケットの条件を満たしておりません。',
      duplicated: 'このメールアドレスは既に登録されています。',
      purchase_expired: '決済の期限が切れてしまいました。再度決済を試してみてください。',
      OrderReferenceCountExceeded: '支払い方法下の『お支払いにAmazon Payを利用する』を確認いただき注文に進んでください。',
      InvalidBillingAgreementStatus: '支払い方法下の『お支払いにAmazon Payを利用する』を確認いただき注文に進んでください。',
      BillingAgreementConstraintsExist: '選択中の支払方法でエラーが発生しました。他の支払方法をご利用ください。',
      ConstraintsExist: '選択中の支払方法でエラーが発生しました。他の支払方法をご利用ください。',
      TransactionTimedOut: '選択中の支払方法でエラーが発生しました。他の支払方法をご利用ください。',
      InvalidPaymentMethod: '選択中の支払方法でエラーが発生しました。他の支払方法をご利用ください。',
      PaymentMethodNotAllowed: '選択中の支払方法でエラーが発生しました。他の支払方法をご利用ください。',
      AmazonRejected: 'Amazon Payのシステムエラーが発生しました、通常決済を選んでください。',
      ResourceNotFound: 'お客様のセッションが切断されました。お手数ですが、再度ログインください。',
      email_duplicated: 'このメールアドレスは既に登録されています。',
      purchase_timeout_cloudfront_notice:
        '購入が完了している可能性がございます。チケットから購入履歴をご確認のうえ、購入が完了していない場合は、少しお時間をおいてから再度お試しください。'
    }
  },
  event: {
    messages: {
      cancelled: 'このイベントは中止になりました',
      finished: 'このイベントは終了しました',
      preview: 'これはプレビュー画面です',
      bad_weather_warning_title: '天候による開催判断について',
      not_match_age_range: '%{userName}様は参加年齢条件を満たしておりません。マイページから年齢をご確認ください。'
    },
    attributes: {
      married_ok: {
        true: '既婚者もOK',
        false: '独身のみ'
      },
      alt_organizer_name: '主催者情報',
      banner_stamp_type: {
        selling_to_male: '男性先行中!',
        selling_to_female: '女性先行中!',
        recruitment_urgently_male: '男性急募',
        recruitment_urgently_female: '女性急募',
        sold_out_for_male: '男性チケット完売',
        sold_out_for_female: '女性チケット完売',
        sold_to_people: '{amount}名突破'
      },
      event_type: {
        machicon: '街コン',
        'petit-con': 'プチ街コン',
        party: '恋活パーティー',
        konkatsu: '婚活パーティー・お見合いパーティー',
        jibunmigaki: '自分磨き・セミナー',
        activity: '体験コン・アクティビティー',
        interest: '趣味コン',
        bar_gourmet: 'バル・グルメイベント',
        other: 'その他'
      },
      num_of_people_range: {
        no_show: '表示なし',
        from2to6: '2～6名',
        from4to12: '4～12名',
        from10to24: '10～24名',
        from20to48: '20～48名',
        from40to64: '40～64名',
        greater60: '60名以上'
      },
      address_location: {
        no_show: '表示なし',
        direct_station: '駅直結',
        nearby_station: '駅徒歩10分以内'
      },
      address_venue: {
        no_show: '表示なし',
        restaurant: '飲食店',
        chartered_restaurant: '飲食店(貸切)',
        chartered_venue: '貸切会場',
        outdoor: '屋外イベント',
        multiple_places: '複数店舗開催',
        other: 'その他'
      },
      address_parking_lot: {
        no_show: '表示なし',
        yes: 'あり',
        no: 'なし'
      },
      seating_style: {
        sit_down: '着席',
        stand_up: '立席',
        both: '着席+立席',
        other_format: 'その他'
      },
      food_provider: {
        course: 'コース料理',
        single: '単品料理',
        buffet: 'ビュッフェ',
        snack: 'おつまみ・お菓子',
        other: 'その他'
      },
      drink_provider: {
        alcohol_unlimited: 'アルコール提供あり',
        alcohol_cash_on: 'アルコール提供あり',
        alcohol_other: 'アルコール提供あり',
        soft_drink_unlimited: 'ソフトドリンクのみ',
        soft_drink_cash_on: 'ソフトドリンクのみ',
        soft_drink_other: 'ソフトドリンクのみ'
      },
      drink_provider_style: {
        alcohol_unlimited: '飲み放題',
        alcohol_cash_on: 'キャッシュオン',
        soft_drink_unlimited: '飲み放題',
        soft_drink_cash_on: 'キャッシュオン'
      },
      event_optional_style: {
        oneonone: '1対1で話せる',
        has_freetime: 'フリータイムあり',
        has_seat_changing: '席替えあり',
        has_dresscode: 'ドレスコードあり',
        has_recreation: 'レクリエーションあり'
      },
      sit_with_companion: {
        yes: 'あり',
        no: 'なし'
      }
    },
    purpose: {
      marriage_partner: '結婚相手を探す',
      lover: '恋人を探す',
      same_hobbies: '趣味が合う異性を探す',
      friends: '友達を探す',
      jibunmigaki: '自分磨き・セミナー',
      bar_gourmet: 'バル・グルメ'
    }
  },
  purchase: {
    attributes: {
      custom_question_answer1: 'Q1(必須)',
      custom_question_answer2: 'Q2'
    },
    enum: {
      payment_method: {
        ntt_bank: '銀行振込',
        ntt_cc: 'ちょコムクレジット支払い',
        ntt_cvs: 'コンビニ',
        ntt_emoney: 'ちょコムeマネー',
        sbpayment_au: 'au PAY（auかんたん決済）',
        sbpayment_softbank: 'ソフトバンクまとめて支払い',
        paypal: 'PayPal',
        free: '無料チケット',
        transfer: 'イベント振替',
        ntt_docomo: 'd払い',
        ntt_docomo_easy_payment: 'd払い',
        amazon_pay: 'Amazon Pay',
        stripe_cc: 'クレジットカード',
        stripe_cc_easy_payment: 'クレジットカード',
        stripe_cvs: 'コンビニ',
        sbpayment_paypay: 'PayPay'
      }
    },
    confirmation_statement: {
      ntt_bank: '---',
      ntt_cc: ' ',
      ntt_cvs: 'ご入金後、サイトの反映に最大6時間ほど時間を要することがございます。',
      ntt_emoney:
        'ちょコム残高が足りない場合は決済をやり直しになります。足りない場合はあらかじめ<a href="https://www.chocom.net/user/html/E22Login.html" target="_blank">チャージ</a>をしておいてください。チャージの反映に3時間ほど時間を要することがございますのでイベントの直前のご購入はお控えください。',
      paypal: '---',
      free: ' '
    },
    cvs_name: {
      'seven-eleven': 'セブンイレブン',
      lawson: 'ローソン',
      seicomart: 'セイコーマート',
      ministop: 'ミニストップ',
      familymart: 'ファミリーマート'
    }
  },
  subscription: {
    enum: {
      subscription_type: {
        konkatsu_freepass: '婚活フリーパス',
        mens_pass: 'メンズパス'
      },
      status: {
        active: '有効',
        inactive: '無効'
      },
      auto_renew_status: {
        auto_renew_enabled: '継続購入中',
        auto_renew_disabled: '停止済み'
      }
    }
  },
  survey_question: {
    question_type: {
      select_11_number: {
        0: 0,
        1: 1,
        2: 2,
        3: 3,
        4: 4,
        5: 5,
        6: 6,
        7: 7,
        8: 8,
        9: 9,
        10: 10
      },
      select_6_satisfaction: {
        1: 'とても不満',
        2: '不満',
        3: '少し不満',
        4: '少し満足',
        5: '満足',
        6: 'とても満足'
      },
      select_6_importance: {
        1: '全く重要ではない',
        2: '重要ではない',
        3: 'あまり重要ではない',
        4: '少し重要',
        5: '重要',
        6: 'とても重要'
      }
    },
    not_want_to: 'したいと思わない',
    want_to: 'したいと思う'
  },
  ticket: {
    attributes: {
      status: {
        0: '参加者調整中',
        end_of_sale: '✖販売終了',
        sold_out: '参加者調整中',
        female_wanted: '〇女性急募‼',
        male_wanted: '〇男性急募‼',
        '1-49': '△残りわずか',
        '50-100': '◎受付中',
        accepting_lotteries: '◎抽選受付中',
        lottery_wating: '(抽選申込み　受付済み)',
        ratio_adjustmenting: '参加者調整中',
        finish_lottery: '抽選受付終了',
        end_of_sale_modal: '完売',
        ratio_adjustmenting_modal: '参加者調整中',
        lottery_ticket: '抽選申込',
        sold_out_modal: '参加者調整中'
      },
      name: {
        female: '女性',
        male: '男性',
        both_gender: '男女'
      }
    }
  }
}
